import { get } from "lodash";

/* @ngInject */
function angularRun(
  $rootScope,
  $state,
  $window,
  $uibModalStack,
  $timeout,
  amMoment,
  $log,
  SecurityManager,
  TrackingStateService,
  LocaleService
) {
  // Global vars
  $rootScope.user = null;
  $rootScope.organization = null;
  $rootScope.returnToState = null;
  $rootScope.isSidebarActive = false;
  $rootScope.showBackdrop = false;
  $rootScope.hasQuotes = true;
  $rootScope.$state = $state;

  // Configure angular moment language
  if ($window.navigator.language.split("-")[0] === "es")
    LocaleService.setLanguage("es");
  else LocaleService.setLanguage("en");

  $rootScope.$on(
    "$stateChangeStart",
    function (event, toState, toParams, fromState, fromParams) {
      $rootScope.isSidebarActive = false;

      // Debugger.debugRoutes(fromState, fromParams, toState, toParams)

      // Close all modals if the page change
      $uibModalStack.dismissAll();

      // Check if the page requires authorization and if user is authenticated else redirects to login page.
      if (
        toState.data &&
        toState.data.requiresLogin &&
        !SecurityManager.isAuthenticated()
      ) {
        event.preventDefault();
        $rootScope.returnToState = {
          state: toState.name,
          params: toParams,
        };
        $state.go("login");
      }
    }
  );

  $rootScope.$on(
    "$stateChangeSuccess",
    function (event, toState, toParams, fromState, fromParams) {
      TrackingStateService.trackStateChange(fromState.name, toState.name);

      if (toParams.organization) {
        if (
          get(toState, "data.requiresOwner", false) &&
          !$rootScope.organization.isUserAdmin($rootScope.user.id)
        ) {
          $state.go("app.dashboard");
        }
      }

      $window.scrollTo(0, 0);
    }
  );

  $rootScope.$on(
    "$stateChangeError",
    function (event, toState, toParams, fromState, fromParams, error) {
      $log.log("$stateChangeError");
      $log.log("event", event);
      $log.log("toState", toState);
      $log.log("toParams", toParams);
      $log.log("fromState", fromState);
      $log.log("fromParams", fromParams);
      $log.log("error", error);
      // $state.go('otherwise');
    }
  );

  $window.Offline.on("down", function () {
    $timeout(function () {
      $rootScope.showBackdrop = true;
    });
  });

  $window.Offline.on("up", function () {
    $timeout(function () {
      $rootScope.showBackdrop = false;
    });
  });

  $rootScope.isResetPassword = function () {
    return $state.is("resetPassword");
  };

  $rootScope.isLoginOrSignupOrAccessFromMobile = function () {
    return (
      $state.is("login") || $state.is("signup") || $state.is("accessFromMobile")
    );
  };

  $rootScope.isDashboardNoQuotes = function () {
    return $state.is("app.dashboard") && !$rootScope.hasQuotes;
  };

  $rootScope.isAccessFromMobile = function () {
    return $state.is("accessFromMobile");
  };
}

export default angularRun;
